export default __webpack_public_path__ + "static/media/logo.f3942a90.png";